import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { BoardDetailsComponent } from './board-details/board-details.component';
import { QuoteDetailsComponent } from './quote-details/quote-details.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrderReviewComponent } from './order-review/order-review.component';
import { OrderStatusComponent } from './order-status/order-status.component';
// import { LoginPagesComponent } from './login-pages/login-pages.component';
import { AssemblyProcessComponent } from './assembly-process/assembly-process.component';
// import { CreateAddressComponent } from './create-address/create-address.component';
import { BomAssemblyProcessComponent } from './bom-assembly-process/bom-assembly-process.component';
import { SearchAssistComponent } from './search-assist/search-assist.component';
import { BomProcessComponent } from './bom-process/bom-process.component';
import { ComponentProcurementComponent } from './component-procurement/component-procurement.component';
import { QuoteStatusComponent } from './quote-status/quote-status.component';
// import { CustomQuoteDashboardComponent } from './custom-quote-dashboard/custom-quote-dashboard.component';
import {AdditionalComponentDetailsComponent} from './additional-component-details/additional-component-details.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { CustomQuoteComponentProcurementComponent } from './custom-quote-component-procurement/custom-quote-component-procurement.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'home',
    component:HomeComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'boardDetails',
    component:BoardDetailsComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  
  {
    path: 'quoteDetails',
    component:QuoteDetailsComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'quoteStatus',
    component:QuoteStatusComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'bomPreProcess',
    component:BomProcessComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'componentProcurement',
    component:ComponentProcurementComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'bomAssemblyProcess',
    component:BomAssemblyProcessComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'orderDetails',
    component:OrderDetailsComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  // {
  //   path: 'addNewAddress',
  //   component:CreateAddressComponent,
  //   children: []
  //   // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  // },
  {
    path: 'orderReview',
    component:OrderReviewComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'orderstatus',
    component:OrderStatusComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  // {
  //   path: 'loginpage',
  //   component:LoginPagesComponent,
  //   children: []
  //   // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  // },
  {
    path: 'assemblyProcess',
    component:AssemblyProcessComponent,
    children: []
    // loadChildren: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'searchAssist',
    component:SearchAssistComponent,
    children: []
  },
  {
    path: 'aditinalComponentDetails',
    component:AdditionalComponentDetailsComponent,
    children: []
  },
  // {
  //   path:'customQuoteDashboard',
  //   component: CustomQuoteDashboardComponent,
  //   children:[]
  // },
  {
    path:'ad-dashboard',
    component: AdminDashboardComponent,
    children:[]
  },
  {
    path:'customQuoteComponentProcurement',
    component: CustomQuoteComponentProcurementComponent,
    children:[]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
